import { map as _map, find as _find, filter as _filter } from 'lodash';
import { CART_PRODUCT_TYPES } from "../../constants/index.js";
import { getAddonsLabel, getHotelName, getActivityName } from "../products.utils/index.js";
import { formatPriceOnlyValue } from "../format.utils/index.js";
export function getProductName(product, type) {
  switch (true) {
    case type === CART_PRODUCT_TYPES.FLIGHT:
      return type;
      break;
    case type === CART_PRODUCT_TYPES.HOTEL:
      return getHotelName(product);
      break;
    case type === CART_PRODUCT_TYPES.ACTIVITIES:
      return getActivityName(product);
      break;
    default:
      return getAddonsLabel(product);
      break;
  }
}
export function getSaleProductLineItem(saleNumber, currency, bookings, cartsObject, carts) {
  return saleNumber ? getProductFromBookings(currency, bookings) : getProductFromCarts(currency, cartsObject, carts);
}
export function getProductFromBookings(currency, bookings) {
  return _map(bookings, function (booking) {
    var _booking$displayItems, _booking$displayItems2;
    var product = _find(booking === null || booking === void 0 ? void 0 : booking.products, function (p) {
      return (p === null || p === void 0 ? void 0 : p.type) === (booking === null || booking === void 0 ? void 0 : booking.type);
    });
    return {
      id: booking === null || booking === void 0 ? void 0 : booking.id,
      label: getProductName(product, booking === null || booking === void 0 ? void 0 : booking.type),
      price: {
        currency: currency,
        total: formatPriceOnlyValue(booking === null || booking === void 0 ? void 0 : (_booking$displayItems = booking.displayItems) === null || _booking$displayItems === void 0 ? void 0 : (_booking$displayItems2 = _booking$displayItems.total) === null || _booking$displayItems2 === void 0 ? void 0 : _booking$displayItems2.total)
      },
      type: booking.type
    };
  });
}
export function getProductFromCarts(currency, cartsObject, carts) {
  return _map(carts, function (cartObj) {
    var _cart$displayItems, _cart$displayItems$to;
    var cart = _find(cartsObject, function (c) {
      return c.cartId === cartObj.cartId;
    });
    var product = _find(cart === null || cart === void 0 ? void 0 : cart.products, function (p) {
      return (p === null || p === void 0 ? void 0 : p.type) === cartObj.type;
    });
    return {
      id: cart === null || cart === void 0 ? void 0 : cart.cartId,
      label: getProductName(product, cartObj === null || cartObj === void 0 ? void 0 : cartObj.type),
      price: {
        currency: currency,
        total: formatPriceOnlyValue((_cart$displayItems = cart.displayItems) === null || _cart$displayItems === void 0 ? void 0 : (_cart$displayItems$to = _cart$displayItems.total) === null || _cart$displayItems$to === void 0 ? void 0 : _cart$displayItems$to.total)
      },
      type: cartObj === null || cartObj === void 0 ? void 0 : cartObj.type
    };
  });
}
export function getSalePaymentLineItem(payments, keyToReadPrice, currency, total, hasMultiCart) {
  var salePayment = [];
  var loyaltyPayments = _filter(payments, function (p) {
    return (p === null || p === void 0 ? void 0 : p.type) === CART_PRODUCT_TYPES.LOYALTY;
  });
  if (loyaltyPayments.length > 0) {
    salePayment.push({
      label: hasMultiCart ? 'overall-total' : 'total',
      type: hasMultiCart ? 'overall-total' : 'total',
      price: {
        currency: total === null || total === void 0 ? void 0 : total.currency,
        total: formatPriceOnlyValue(total === null || total === void 0 ? void 0 : total.total)
      }
    });
  }
  _map(loyaltyPayments, function (line) {
    salePayment.push({
      id: line === null || line === void 0 ? void 0 : line.id,
      label: line === null || line === void 0 ? void 0 : line.category,
      price: {
        currency: currency,
        total: formatPriceOnlyValue(line.price[keyToReadPrice])
      },
      type: line === null || line === void 0 ? void 0 : line.category,
      isNegetiveRule: true
    });
  });
  return salePayment;
}
export function getSaleTotalLineItem(total, saleNumber) {
  return !saleNumber ? [{
    label: 'totalToBePaid',
    type: 'totalToBePaid',
    price: {
      currency: total === null || total === void 0 ? void 0 : total.currency,
      total: formatPriceOnlyValue(total === null || total === void 0 ? void 0 : total.totalToBePaid)
    }
  }] : [{
    label: 'total',
    type: 'overall-total',
    price: {
      currency: total === null || total === void 0 ? void 0 : total.currency,
      total: formatPriceOnlyValue(total === null || total === void 0 ? void 0 : total.total)
    }
  }];
}
export function getSalesTotalBreakdownLineItems(total) {
  return [{
    label: 'Vat',
    type: 'vat',
    price: {
      currency: total === null || total === void 0 ? void 0 : total.currency,
      total: formatPriceOnlyValue(total === null || total === void 0 ? void 0 : total.vat)
    }
  }, {
    label: 'subTotal',
    type: 'subTotal',
    price: {
      currency: total === null || total === void 0 ? void 0 : total.currency,
      total: formatPriceOnlyValue(total === null || total === void 0 ? void 0 : total.subTotal)
    }
  }];
}